import PropTypes from "prop-types";
import { useLocales } from "../../../../locales";
import {
  PLATFORM_DISPLAY_NAME_KEYS,
  PLATFORM_STATIC_ICONS,
  additonalPlatformIcons,
} from "../../../../config/icons";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import {overviewCardConfig} from "../../../../config/analytics/analyticsCardsConfig";

export function PlatformRow({ platformInfo, data, platform, hasDetails, dataDelay1Day }) {
  const { translate: t, currentLang } = useLocales();

  return (
    <div
      className="border border-gray-300 border-dashed rounded py-2 px-4 mb-2 d-flex  "
      key={platform}
    >
      <div className="d-flex align-items-center col-3">
        <div className="h-35px mw-100">
          <img className={'h-100'} alt="Pic" src={PLATFORM_STATIC_ICONS[platform]} />
        </div>
        {additonalPlatformIcons[platform] && (
          <div className="d-flex align-items-end">
            <div className="ms-1" style={{ marginBottom: -20 }}>
              <i className={`fs-1x ${additonalPlatformIcons[platform]}`} />
            </div>
          </div>
        )}
      </div>

      <div className="col-9">
        <div className="text-truncate">
          <p className="m-0 fw-bold align-self-start">{platformInfo?.name ? platformInfo.name : t(PLATFORM_DISPLAY_NAME_KEYS[platform])}</p>
        </div>

        {data && (
          <div className="d-flex justify-content-between flex-end ">
            <p className="me-2 small fw-bold text-muted p-0 m-0">
              {t(
                  overviewCardConfig[platform].translation_key_single
              )}:&nbsp;

              {new Intl.NumberFormat(currentLang.value).format(
                Math.ceil(data?.displayValue)
              )}{' '}

            </p>
            {data.displayPercentage === 0 && (
              <OverlayTrigger
                placement="top"
                overlay={
                  <Tooltip>
                    {data.oldValue !== null && data.oldValue !== undefined ? (
                      <>{data.oldValue} </>
                    ) : (
                      <b>-</b>
                    )}
                  </Tooltip>
                }
              >
                <div className="m-0">
                  <span className="badge badge-light">
                    {data.displayPercentage} % | {new Intl.NumberFormat(currentLang.value).format(
                      Math.ceil(data.displayValue - data.oldValue))}
                  </span>
                </div>
              </OverlayTrigger>
            )}
            {data.displayPercentage !== undefined &&
              data.displayPercentage !== 0 && (
                <div className="m-0">
                  <OverlayTrigger
                    placement="top"
                    overlay={
                      <Tooltip>
                        {data.oldValue !== null &&
                        data.oldValue !== undefined ? (
                          <>
                            <span className={"me-2"}>
                              {t("overallCard.value_time_range_before")}:
                            </span>
                            {new Intl.NumberFormat(
                              currentLang.value,
                              {}
                            ).format(Math.ceil(data?.oldValue))}{' '}
                          </>
                        ) : (
                          <b>-</b>
                        )}
                      </Tooltip>
                    }
                  >
                    <div className="m-0">
                      <span
                        className={`badge ${
                          data?.trend < 0
                            ? "badge-light-danger"
                            : "badge-light-success"
                        } fs-base`}
                      >
                        <i
                          className={`fa-duotone fs-5 ${
                            data?.trend < 0
                              ? "fa-arrow-down text-danger"
                              : "fa-arrow-up text-success"
                          }  ms-n1 me-2`}
                        ></i>
                        {data.displayPercentage} % | {new Intl.NumberFormat(
                          currentLang.value,
                          {}
                      ).format(Math.ceil(data.displayValue - data.oldValue))}
                      </span>
                    </div>
                  </OverlayTrigger>
                </div>
              )}
          </div>
        )}
        {!data && !hasDetails && (
          <div className={"d-flex justify-content-end"}>
            <OverlayTrigger
              placement="top"
              overlay={<Tooltip>{t("overallCard.no_data_available")}</Tooltip>}
            >
              <i className="fa-duotone fa-circle-info fa-sm"></i>
            </OverlayTrigger>
          </div>
        )}
        {!data && hasDetails && (
          <div className={"d-flex justify-content-end"}>
            <OverlayTrigger
              placement="top"
              overlay={<Tooltip>{t("overallCard.sync_in_progress")}</Tooltip>}
            >
              <i className="fa-duotone fa-rotate fa-sm"></i>
            </OverlayTrigger>
          </div>
        )}
      </div>
    </div>
  );
}

PlatformRow.propTypes = {
  platform: PropTypes.string,
  platformInfo: PropTypes.object,
  data: PropTypes.object,
  displayValue: PropTypes.number,
  hasDetails: PropTypes.bool,
  dataDelay1Day: PropTypes.bool
};
